var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 17,
    viewBox: "0 0 8 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14115 0.321239C6.56907 -0.109797 7.25979 -0.106666 7.68391 0.328234C8.10803 0.763134 8.10495 1.46511 7.67703 1.89615L5.11271 4.47913C4.07199 5.52742 3.3581 6.24887 2.87504 6.86017C2.40581 7.45398 2.24483 7.8354 2.20199 8.17699C2.17509 8.39148 2.17509 8.60851 2.20199 8.82301C2.24483 9.1646 2.40581 9.54602 2.87504 10.1398C3.3581 10.7511 4.07199 11.4726 5.11271 12.5209L7.67703 15.1038C8.10495 15.5349 8.10803 16.2369 7.68391 16.6718C7.25979 17.1067 6.56907 17.1098 6.14115 16.6788L3.53063 14.0492C2.54741 13.0589 1.74379 12.2495 1.1739 11.5283C0.581275 10.7783 0.152284 10.0171 0.037686 9.10337C-0.0125612 8.70272 -0.0125612 8.29728 0.037686 7.89663C0.152284 6.9829 0.581276 6.22168 1.1739 5.47172C1.7438 4.75052 2.54739 3.94111 3.53062 2.95076L6.14115 0.321239Z",
    fill: "#42474D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.fcea85c27becd8b01d9db7c3a8349434.svg";
export { ForwardRef as ReactComponent };